import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import AdditionalDamage from './additional-damage.jsx';
import DatePicker from 'react-datepicker';
import moment from 'moment';
export default class ThisDriversArchivedAdditionalDamages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      url: props.url || '/api/v1/portal/drivers/additional-damages',
      additionalDamageAccountId: props.additionalDamageAccountId || null,
      additionalDamages: [],
    };
    this.handleAdditionalDamagesTableRefresharc = this.handleAdditionalDamagesTableRefresharc.bind(this);
    this.handleAdditionalDamagesTableRefresh = this.handleAdditionalDamagesTableRefresh.bind(this);
    this.editModalManage = this.editModalManage.bind(this);
    this.handleCallParentMethod = this.handleCallParentMethod.bind(this);
  }

  componentDidMount() {
    var that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/additional-damages/'+
      this.state.additionalDamageAccountId+'/archived',
      method: 'GET',
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(additionalDamagesJson) {
      that.setState({
        additionalDamages: additionalDamagesJson,
        isLoading: false
      });
    });
  }  
  handleAdditionalDamagesTableRefresh(){
    console.log(this.state.additionalDamageAccountId);
    var that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/additional-damages/'+this.state.additionalDamageAccountId+'/current',
      method: 'GET',
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(additionalDamagesJson) {
      
      that.setState({
        additionalDamages: additionalDamagesJson,
        isLoading: false
      });
    });
  }
  handleAdditionalDamagesTableRefresharc(){
    var that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/additional-damages/'+
      this.state.additionalDamageAccountId+'/archived',
      method: 'GET',
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(additionalDamagesJson) {
      that.setState({
        additionalDamages: additionalDamagesJson,
        isLoading: false
      });
    });
  }
  editModalManage(editId){
    $('#'+editId+'-edit-row').toggleClass('toggle-hide');
  }
  handleCallParentMethod(total, paid_total){
    this.props.handleTotalAmountUpdate(total);
    this.props.handlePaidAmountUpdate(paid_total);
  }

  render() {
    var AdditionalDamagearr = [];
      let editModalManage = this.editModalManage;
      let handleAdditionalDamagesTableRefresharc = this.handleAdditionalDamagesTableRefresharc;
      let handleAdditionalDamagesTableRefresh = this.handleAdditionalDamagesTableRefresh;
      let handleCallParentMethod = this.handleCallParentMethod;

    if (this.state.additionalDamages && this.state.additionalDamages.length > 0) {
      this.state.additionalDamages.forEach(function(i, index) {
        AdditionalDamagearr.push(<AdditionalDamage key={'additionalDamage-'+i.id} data={i} 
              handleAdditionalDamagesTableRefresharc={handleAdditionalDamagesTableRefresharc}
              editModalManage={editModalManage}
              handleCallParentMethod={handleCallParentMethod}/>);
      AdditionalDamagearr.push(
              <tr id={i.id+"-edit-row"} key={'additionalDamage-'+index} className="toggle-hide">
                <td colSpan="8"> 
                  <EditModal data={i}
                  handleAdditionalDamagesTableRefresharc={handleAdditionalDamagesTableRefresharc}
                  handleAdditionalDamagesTableRefresh={handleAdditionalDamagesTableRefresh}
                  editModalManage={editModalManage}
                  handleCallParentMethod={handleCallParentMethod} />
                </td>
              </tr>
            );
        });
    }
    return (
        <div>
            <div className="row additionalDamages-table-header">
                
            <table className="driver-wages-table"> 
                  <thead>
                    <tr className="additional_damages-table-header">
                      <th>description</th>
                      <th>ref</th>
                      <th>amounts</th>
                      <th>frequency</th>
                      <th>StartDate</th>
                      <th>EndDate</th>
                      <th>Edit</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                      {AdditionalDamagearr}
                  </tbody>
              </table>
            </div>
        </div>
    );
  }
}

class EditModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      data: props.data || null,
    };
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleDeductionOccurance = this.handleDeductionOccurance.bind(this);
  }
  handleStartDateChange(date) {
    this.state.data.start_date = date;
    this.setState({data: this.state.data});
  }
  handleEndDateChange(date) {
    this.state.data.end_date = date;
    this.setState({data: this.state.data});
  }
  handleDeductionOccurance(e){
    this.state.data.deduction_occurance =  e.target.value;
    this.setState({data: this.state.data});
  }
  handleDescChange(e){
    this.state.data.description =  e.target.value;
    this.setState({data: this.state.data});
  }
  handleRefChange(e){
    this.state.data.insurance_reference =  e.target.value;
    this.setState({data: this.state.data});
  }
  handleOriginalAmountChange(e){
    this.state.data.original_amount_to_repay =  e.target.value;
    this.setState({data: this.state.data});
  }
  handleAgreedAmountChange(e){
    this.state.data.agreed_deduction_amount =  e.target.value;
    this.setState({data: this.state.data});
  }
  handleEditFormSubmitButtonClick(e){
    e.preventDefault();
    let that = this;
    this.setState({isLoading:true});
    let editData = {
      api_token: window.api_token,
      driver_id: this.state.data.driver_id,
      id:this.state.data.id,
      description: this.state.data.description,
      insurance_reference: this.state.data.insurance_reference,
      original_amount_to_repay: this.state.data.original_amount_to_repay,
      deduction_occurance: this.state.data.deduction_occurance,
      agreed_deduction_amount: this.state.data.agreed_deduction_amount,
      start_date: (this.state.data.start_date != null) ? moment(this.state.data.start_date).format("YYYY-MM-DD") : null,
      end_date: (this.state.data.end_date != null) ? moment(this.state.data.end_date).format("YYYY-MM-DD") : null,
    };
    $.ajax({
      type: "POST",
      url: '/api/v1/portal/drivers/additional-damages/edit-additional-damages',
      data: editData,
      dataType: "text/json",
      complete: function(response) {
        that.setState({isLoading:false});
        if (response.status == 200) {
          $('#infomodallabel').html('AdditionalDamage');
          $('#infomodal .modal-body').html('AdditionalDamage has been updated sucessfully..');
          $('#infomodal').modal();
          that.props.handleAdditionalDamagesTableRefresharc();
          that.props.handleAdditionalDamagesTableRefresh();
          that.props.editModalManage(that.state.data.id);
          let txt = JSON.parse(response.responseText)
          that.props.handleCallParentMethod(txt.total, txt.total_paid);
        }
        else {
          $('#infomodallabel').html('Error updating AdditionalDamage');
          $('#infomodal .modal-body').html($.parseHTML(
            response.responseText.
            replace(/\"/g, ""))
          );
          $('#infomodal').modal();
        }
      }
    });
    return false;
  }
  render() {
    return (
      
        <fieldset>
          <div className="row">
            <div className="col-md-6 text-right">Description</div>
            <div className="col-md-6 text-left">
              {/* <input
                className="form-control form-control-lg"
                name="description"
                type="text" placeholder="description" 
                value={this.state.data.description}
                onChange={(e)=>this.handleDescChange(e)}/> */}
                <select name="description" className="form-control form-control-lg"
                value={this.state.data.description}
                onChange={(e)=>this.handleDescChange(e)}>
                  <option value="alloy_wheel">ALLOY WHEEL</option>
                  <option value="fuel_deduction">FUEL DEDUCTION</option>
                  <option value="trade_plate_replacement">TRADE PLATE RENTAL REPLACEMENT</option>
                  <option value="windscreen">WINDSCREEN</option>
                  <option value="scratch">SCRATCH</option>
                  <option value="scuff">SCUFF</option>
                  <option value="tyre">TYRE</option>
                  <option value="windmirror">WINDMIRROR</option>
                  <option value="wrong_fuel_in_vehicle">WRONG FUEL IN VEHICLE</option>
                  <option value="dent">DENT</option>
                  <option value="stone_chip">STONE CHIP</option>
                  <option value="interior_damage">INTERIOR DAMAGE</option>
                  <option value="mechanical_fault_caused_by_driver">MECHANICAL FAULT CAUSED BY DRIVER</option>
                  <option value="smoking_in-vehicle">SMOKING IN VEHICLE</option>
                  <option value="christmas_club">CHRISTMAS CLUB</option>
                  <option value="other">OTHER</option>
                </select>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 text-right">Reference</div>
            <div className="col-md-6 text-left">
              <input
              className="form-control form-control-lg"
              name="insurance_reference"
              type="text" placeholder="reference"
              value={this.state.data.insurance_reference} 
              onChange={(e)=>this.handleRefChange(e)}/>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 text-right">Amount to Repay:</div>
            <div className="col-md-6 text-left">
              <input
                className="form-control form-control-lg"
                name="original_amount_to_repay"
                type="text" placeholder="&pound; original amount to repay"
                value={this.state.data.original_amount_to_repay}
                onChange={(e)=>this.handleOriginalAmountChange(e)} />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 text-right">@</div>
            <div className="col-md-6 text-left">
              <input type="text" placeholder="&pound;agreed deduction amount"
              name="agreed_deduction_amount" id="agreed_deduction_amount"
              className="form-control"
              value={this.state.data.agreed_deduction_amount}
              onChange={(e)=>this.handleAgreedAmountChange(e)} />
            per <select name="deduction_occurance" value={this.state.data.deduction_occurance} id="deduction_occurance" onChange={this.handleDeductionOccurance}>
              <option value="weekly">Week</option>
              <option value="monthly">Month</option>
              <option value="daily">Day</option>
              <option value="hourly">Hour</option>
            </select><br />
          </div>
        </div>
        <div className="weekly">
          <div className="row">
            <div className="col-md-6 text-right">Start Date:</div>
            <div className="col-md-6 text-left">
                <DatePicker todayButton={"Today"} dateFormat="dd-MM-yyyy" onChange={this.handleStartDateChange} 
                selected={(this.state.data.start_date) ? moment(this.state.data.start_date).toDate() : null}/>
          </div>
          </div>
          <div className="row">
            <div className="col-md-6 text-right">End Date:</div>
            <div className="col-md-6 text-left">
                <DatePicker todayButton={"Today"} dateFormat="dd-MM-yyyy" onChange={this.handleEndDateChange} 
                selected={(this.state.data.end_date) ? moment(this.state.data.end_date).toDate() : null }/>
            </div>
          </div>
        </div> 
        <div className="row">
            <div className="col-md-6 text-right">&nbsp;</div>
            <div className="col-md-6 text-left">
            <button className="btn btn-sm btn-primary" disabled={(this.state.isLoading) ? true : false}
              onClick={(e) => {
                this.handleEditFormSubmitButtonClick(e)
              }}>
              <i className="fa fa-plus"></i> Save AdditionalDamage</button>
            </div>
            <br/>
        </div>
      </fieldset>
    
    );
  }

}
